import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-modal-body" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "option-stack" }
const _hoisted_4 = { class: "refund-option-amount" }
const _hoisted_5 = {
  key: 0,
  class: "partial-field"
}
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "field-error"
}
const _hoisted_8 = {
  key: 0,
  class: "field-error"
}
const _hoisted_9 = {
  key: 1,
  class: "partial-field"
}
const _hoisted_10 = {
  key: 0,
  class: "field-error"
}
const _hoisted_11 = {
  key: 0,
  class: "field-error field-error--submit"
}
const _hoisted_12 = { class: "modal-actions" }

import { computed, ref, watch } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppTextArea from "@/shared/components/ui/AppTextArea.vue";
import { formatCurrency } from "@/shared/utils/utils";
import { cancelVendorAppointment } from "@/shared/services/appointments.api";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentCancellationActionModal',
  props: {
    appointment: {},
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const selectedOption = ref<"full" | "partial" | "none" | "reject">("full");
const partialRefundAmount = ref("");
const partialRefundError = ref("");
const partialRefundReason = ref("");
const partialRefundReasonError = ref("");
const rejectReason = ref("");
const rejectReasonError = ref("");
const submitError = ref("");
const isSubmitting = ref(false);

const refundBaseAmount = computed(() =>
  normalizeAmount(props.appointment?.total_info?.total_amount)
);
const refundBaseLabel = computed(() =>
  refundBaseAmount.value === null ? "" : formatCurrency(refundBaseAmount.value)
);
const refundBaseDisplay = computed(() => refundBaseLabel.value || "-");
const canContinue = computed(() => {
  if (selectedOption.value === "partial") {
    return (
      isValidPartialRefundAmount(partialRefundAmount.value) &&
      partialRefundReason.value.trim().length > 0
    );
  }
  if (selectedOption.value === "reject") {
    return rejectReason.value.trim().length > 0;
  }
  return true;
});

watch(selectedOption, () => {
  if (partialRefundError.value) partialRefundError.value = "";
  if (rejectReasonError.value) rejectReasonError.value = "";
});

watch(partialRefundAmount, () => {
  if (partialRefundError.value) partialRefundError.value = "";
});

watch(partialRefundReason, () => {
  if (partialRefundReasonError.value) partialRefundReasonError.value = "";
});

watch(rejectReason, () => {
  if (rejectReasonError.value) rejectReasonError.value = "";
});

async function handleSubmit() {
  if (
    selectedOption.value === "partial" &&
    !isValidPartialRefundAmount(partialRefundAmount.value)
  ) {
    partialRefundError.value = "Enter a valid partial refund amount.";
    return;
  }

  if (selectedOption.value === "partial" && !partialRefundReason.value.trim()) {
    partialRefundReasonError.value = "Enter a reason for the partial refund.";
    return;
  }

  if (selectedOption.value === "reject" && !rejectReason.value.trim()) {
    rejectReasonError.value = "Enter a reason for rejecting this request.";
    return;
  }

  if (isSubmitting.value) return;

  submitError.value = "";
  isSubmitting.value = true;

  try {
    await cancelVendorAppointment(props.appointment?.id, {
      refund_type: selectedOption.value,
      ...(selectedOption.value === "partial"
        ? {
            refund_amount: Number(partialRefundAmount.value),
            reason: partialRefundReason.value.trim(),
          }
        : {}),
      ...(selectedOption.value === "reject" ? { reason: rejectReason.value.trim() } : {}),
    });

    await props.onSuccess?.();
    modal.close();
  } catch (error: any) {
    submitError.value =
      error?.response?.data?.message || error?.message || "Failed to cancel appointment.";
    // eslint-disable-next-line no-console
    console.error("cancelVendorAppointment failed", error);
  } finally {
    isSubmitting.value = false;
  }
}

function normalizeAmount(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function isValidPartialRefundAmount(value: string): boolean {
  const amount = Number(value);
  const base = refundBaseAmount.value;
  if (!Number.isFinite(amount) || amount <= 0) return false;
  if (base === null) return false;
  return amount <= base;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "search-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-text text-left" }, "Cancellation Options", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["refund-option", { 'refund-option--selected': selectedOption.value === 'full' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedOption.value = 'full'))
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "refund-option-copy" }, [
              _createElementVNode("p", { class: "refund-option-title" }, "Cancel with full refund"),
              _createElementVNode("p", { class: "refund-option-subtitle" }, "Refund the customer the full amount.")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-cash-refund", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(refundBaseDisplay.value), 1)
            ])
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["refund-option", { 'refund-option--selected': selectedOption.value === 'partial' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedOption.value = 'partial'))
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "refund-option-copy" }, [
              _createElementVNode("p", { class: "refund-option-title" }, "Cancel with partial refund"),
              _createElementVNode("p", { class: "refund-option-subtitle" }, "Refund a portion of the payment.")
            ], -1)),
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-cash-minus", -1)
              ]))]),
              _: 1
            })
          ], 2),
          (selectedOption.value === 'partial')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(AppTextField, {
                      modelValue: partialRefundAmount.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((partialRefundAmount).value = $event)),
                      label: "Partial refund amount",
                      variant: "outlined",
                      type: "number",
                      min: "0",
                      step: "0.01",
                      prefix: "$",
                      placeholder: "Enter refund amount"
                    }, null, 8, ["modelValue"]),
                    (partialRefundError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(partialRefundError.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(AppTextArea, {
                    modelValue: partialRefundReason.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((partialRefundReason).value = $event)),
                    class: "",
                    label: "Reason for partial refund",
                    variant: "outlined",
                    rows: "3",
                    placeholder: "Enter a short reason for the partial refund"
                  }, null, 8, ["modelValue"]),
                  (partialRefundReasonError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(partialRefundReasonError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["refund-option", { 'refund-option--selected': selectedOption.value === 'none' }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedOption.value = 'none'))
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "refund-option-copy" }, [
              _createElementVNode("p", { class: "refund-option-title" }, "Cancel without refund"),
              _createElementVNode("p", { class: "refund-option-subtitle" }, "No refund will be issued.")
            ], -1)),
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("mdi-cash-remove", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["refund-option refund-option--reject", { 'refund-option--selected': selectedOption.value === 'reject' }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (selectedOption.value = 'reject'))
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "refund-option-copy" }, [
              _createElementVNode("p", { class: "refund-option-title" }, "Reject request"),
              _createElementVNode("p", { class: "refund-option-subtitle" }, " Decline the cancellation and keep the appointment active. ")
            ], -1)),
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("mdi-close-circle-outline", -1)
              ]))]),
              _: 1
            })
          ], 2),
          (selectedOption.value === 'reject')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(AppTextArea, {
                  modelValue: rejectReason.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rejectReason).value = $event)),
                  label: "Reason for rejection",
                  variant: "outlined",
                  rows: "3",
                  placeholder: "Enter a short reason for rejecting the request"
                }, null, 8, ["modelValue"]),
                (rejectReasonError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(rejectReasonError.value), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (submitError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(submitError.value), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(AppButtonFlat, {
        size: "small",
        color: "primary",
        block: "",
        disabled: !canContinue.value || isSubmitting.value,
        loading: isSubmitting.value,
        "prepend-icon": "mdi-check",
        style: {"font-size":"15px"},
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
          _createTextVNode(" Submit ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ]))
}
}

})